import React from 'react';

const Skills = () => {
    return (
        <section id="about">
        <div class="containerr mt-5 pt-5">
            <div data-aos="zoom-in">
            <h2 className="skills common">Skills</h2>
        <div className="common-border"></div>
            </div>
        
                    

            <div class="row">
            

                <div class="col-md-6 ">
                    <div data-aos="fade-right"class="about-content">
                        I have a strong knowledge about JS, HTML, CSS, Bootstrap,Material UI, React Js, Node Js. Just not that I am enriching my self everyday with new stuffs.
                    </div>
                   
                </div>
                <div data-aos="fade-left"class="col-md-6 skills-bar">
                    <p>JavaScript</p>
                    <div class="progress" >
                        <div class="progress-bar" style={{width: '80%'}}>80%</div>
                    </div>
                    <p>UI Design</p>
                    <div class="progress" >
                        <div class="progress-bar" style={{width: '85%'}}>85%</div>
                    </div>
                    <p>React</p>
                    <div class="progress" >
                        <div class="progress-bar" style={{width:'80%'}}>80%</div>
                    </div>
                    <p>Bootstrap</p>
                    <div class="progress" >
                        <div class="progress-bar color" style={{width:'70%'}}>70%</div>
                    </div>
                     <p>NodeJs</p>
                    <div class="progress" >
                        <div class="progress-bar" style={{width: '78%'}}>78%</div>
                    </div>
    
                </div>
    
            </div>
        </div>
    
    </section>
    
    );
};

export default Skills;